// src/ChatHeader.tsx
import React from "react";

interface Props {
  darkMode: boolean;
  setDarkMode: (val: boolean) => void;
  colors: any;
}

const ChatHeader: React.FC<Props> = ({ darkMode, setDarkMode, colors }) => {
  return (
    <div
      style={{
        backgroundColor: colors.headerBg,
        color: colors.headerText,
        padding: "15px 20px",
        fontSize: 20,
        fontWeight: "bold",
        display: "flex",
        justifyContent: "space-between",
        alignItems: "center",
      }}
    >
      Gulpies Chat
      <button
        onClick={() => setDarkMode(!darkMode)}
        style={{
          background: "transparent",
          border: "1px solid",
          borderColor: colors.headerText,
          color: colors.headerText,
          borderRadius: 6,
          padding: "4px 10px",
          cursor: "pointer",
          fontSize: 14,
        }}
      >
        {darkMode ? "☀️ Light" : "🌙 Dark"}
      </button>
    </div>
  );
};

export default ChatHeader;
